import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

// Figma palette (Receipt-Image-Verification / flyout attachment statuses).
// Tokenized where the codebase provides matching semantic values; hex otherwise
// to stay 1:1 with the design.
const COLOR_TEXT_PRIMARY = '#1e2c4c'
const COLOR_TEXT_SECONDARY = '#697080'
const COLOR_ALERT = '#d5404a'
const COLOR_ACTION = '#4489f9'
const COLOR_PROGRESS_TRACK = 'rgba(218, 219, 224, 0.6)'
const COLOR_WHITE = '#ffffff'

export default css`
  &.AttachmentListRows {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    width: 100%;

    .dropzone-slot {
      margin-top: ${spacing(1)};
    }

    .attachment-row {
      display: flex;
      align-items: center;
      padding: 8px 0;
      border-radius: 4px;
      position: relative;
      overflow: visible;
    }

    .row-content {
      display: flex;
      flex: 1 1 0;
      min-width: 0;
      gap: 16px;
      align-items: flex-start;
      border: none;
      background: transparent;
      padding: 0;
      cursor: pointer;
      text-align: left;
      font: inherit;
      color: inherit;
      border-radius: 4px;
    }

    .row-content:focus-visible {
      outline: 2px solid ${COLOR_ACTION};
      outline-offset: 2px;
    }

    .thumb {
      position: relative;
      flex-shrink: 0;
      width: 40px;
      height: 40px;
    }

    .thumb-img {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 4px;
      border: 0.4px solid ${base_colorContentBorder};
      overflow: hidden;
      box-shadow: 0 0.8px 2px 0 rgba(0, 0, 0, 0.1);
    }

    .thumb-img img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      pointer-events: none;
    }

    .thumb-placeholder {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid ${base_colorContentBorder};
      background: ${base_colorSurfaceSecondary};
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .badge-stack {
      position: absolute;
      bottom: -6px;
      right: -5px;
      display: flex;
      align-items: center;
      padding-right: 4px;
    }

    .badge-stack .badge {
      position: relative;
      bottom: auto;
      right: auto;
      margin-right: -4px;
    }

    .badge {
      position: absolute;
      bottom: -6px;
      right: -5px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid ${COLOR_WHITE};
      display: inline-flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      box-sizing: border-box;
      background: ${COLOR_WHITE};
    }

    .badge--verified {
      background: transparent;
      border: none;
      overflow: visible;
      bottom: -4px;
      right: -3px;
    }

    .badge--not-verified {
      background: transparent;
      border: none;
      overflow: visible;
      bottom: -4px;
      right: -3px;
    }

    .badge--erp-failed {
      background: transparent;
      border: none;
      overflow: visible;
      bottom: -4px;
      right: -3px;
    }

    .badge--erp-success {
      padding: 0;
      background: ${COLOR_WHITE};
    }

    .badge--erp-success img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }

    .badge--auto-matched {
      background: transparent;
      border: none;
      overflow: visible;
      bottom: -4px;
      right: -3px;
    }

    .text-block {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      min-width: 0;
      gap: 0;
    }

    .filename {
      font-family: Rubik, sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: ${COLOR_TEXT_PRIMARY};
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 0;
    }

    .filename--error {
      color: ${COLOR_ALERT};
    }

    .meta {
      display: flex;
      gap: 8px;
      align-items: baseline;
      font-family: Rubik, sans-serif;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: ${COLOR_TEXT_SECONDARY};
      margin: 0;
    }

    .meta-sep {
      color: ${COLOR_TEXT_SECONDARY};
    }

    .row--error .filename,
    .row--error .meta,
    .row--error .meta-sep {
      color: ${COLOR_ALERT};
    }

    .meta-error {
      color: ${COLOR_ALERT};
    }

    .meta-default {
      color: ${COLOR_TEXT_SECONDARY};
    }

    .progress {
      width: 200px;
      height: 4px;
      border-radius: 4px;
      overflow: hidden;
      background: ${COLOR_PROGRESS_TRACK};
      margin-top: 6px;
      position: relative;
    }

    .progress-fill {
      height: 100%;
      background: ${COLOR_ACTION};
      width: 40%;
      border-radius: 4px;
      animation: attachment-row-indeterminate 1.2s ease-in-out infinite
        alternate;
      animation-delay: -0.6s;
    }

    .progress--error .progress-fill {
      background: ${COLOR_ALERT};
      animation: none;
      width: 100%;
    }

    @keyframes attachment-row-indeterminate {
      from {
        margin-left: 0;
      }
      to {
        margin-left: 60%;
      }
    }

    .trash-btn {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      margin-left: 16px;
      border: none;
      background: transparent;
      padding: 0;
      cursor: pointer;
      color: ${COLOR_TEXT_SECONDARY};
      opacity: 0;
      transition: opacity 0.15s ease-out;
      align-self: center;
    }

    .trash-btn .trash-hover {
      display: none;
    }

    .trash-btn:hover .trash-default {
      display: none;
    }

    .trash-btn:hover .trash-hover {
      display: block;
    }

    .trash-btn:focus-visible {
      outline: 2px solid ${COLOR_ACTION};
      outline-offset: 2px;
      opacity: 1;
      border-radius: 4px;
    }

    .attachment-row:hover .trash-btn,
    .attachment-row:focus-within .trash-btn {
      opacity: 1;
    }
  }
`
